/* Last Mile Co. storefront v2 (theme v49). Small, dependency free.
   - reveal on scroll for .lm-reveal
   - tab switching for sections/lmc-product-tabs
   - review rail arrows for sections/lmc-reviews
   - quick add size buttons on product cards (snippets/card-product.liquid)
   - free shipping meter inside the cart drawer
   - Size guide link on the product page opens the size guide accordion
   The free shipping threshold comes from window.LMC_FREE_SHIP_CENTS, set in
   snippets/lmc-v2-head.liquid.
   This file is loaded with defer from <head> BEFORE Dawn's pubsub.js, so
   anything that needs subscribe() or PUB_SUB_EVENTS waits for
   DOMContentLoaded (boot) or runs at click time. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('lm-ready');

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* reveal */
  function initReveal() {
    var els = document.querySelectorAll('.lm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* tabs */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-tab]');
    if (!b) return;
    var wrap = b.closest('[data-lm-tabs]');
    if (!wrap) return;
    var key = b.getAttribute('data-lm-tab');
    wrap.querySelectorAll('[data-lm-tab]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    wrap.querySelectorAll('[data-lm-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-lm-panel') !== key; });
  });

  /* rail arrows */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-rail]');
    if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls'));
    if (!rail) return;
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : 320;
    rail.scrollBy({ left: step * parseInt(b.getAttribute('data-lm-rail'), 10), behavior: 'smooth' });
  });

  /* quick add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled || b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var body = { id: parseInt(b.getAttribute('data-lm-add'), 10), quantity: 1 };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (json) {
      b.classList.remove('is-busy');
      if (json.status) { alert(json.description || 'Could not add that size.'); return; }
      try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lm-quick-add', productVariantId: body.id, cartData: json }); } catch (err) {}
      if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
        setTimeout(refreshMeter, 200);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () { b.classList.remove('is-busy'); window.location.href = '/cart'; });
  });

  /* free shipping meter in the cart drawer.
     Restyled 26 Oct 2026 (theme v53): a striped gold bar fills toward a
     checkered flag, with a Dyna style bike riding the leading edge. Styles are in
     assets/lmc-ship-meter.css, shared with the cart page meter.
     Dawn swaps the drawer's HTML on every cart change, which removes the
     meter; the MutationObserver below rebuilds it. lastPct remembers where
     the bar was, so the new one starts there and rides forward instead of
     jumping. Crossing the line adds is-hit for a one-time gold flash. */
  var THRESHOLD = window.LMC_FREE_SHIP_CENTS || 7000;
  var meterBusy = false;
  var lastPct = null;
  var BIKE = '<svg viewBox="0 0 64 36" focusable="false"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="13" cy="27" r="7.6" stroke-width="2.6"/><circle cx="52" cy="27" r="7.8" stroke-width="1.9"/><path d="M4.6 24.2A9 9 0 0 1 15.4 18.7" stroke-width="2"/><path d="M13 27L28 25" stroke-width="2.2"/><path d="M15.2 25L19.4 15.8" stroke-width="2.2"/><path d="M42.4 9.8L37.6 23.6" stroke-width="1.8"/><path d="M42.2 9.2L52 27" stroke-width="2.1"/><path d="M42.5 9.4L43.1 3.6L39.4 4" stroke-width="1.8"/><path d="M36.5 27.2L27.5 28.4L18.2 25.2" stroke-width="1.8"/><circle cx="32" cy="24.6" r="3.2" stroke-width="1.9"/><path d="M30.1 21.6L28.2 16.8" stroke-width="3.4" stroke-linecap="butt"/><path d="M33.9 21.6L36.2 16.9" stroke-width="3.4" stroke-linecap="butt"/></g><g fill="currentColor"><circle cx="13" cy="27" r="1.5"/><circle cx="52" cy="27" r="1.2"/><path d="M13 16.6L14.3 13.9C16 13.3 18 13.2 19.4 13.6L20.8 15.2L27.6 14.6L28.6 15.8C23.6 16.8 18.2 17.1 13 16.6Z"/><path d="M28.2 14.6C30.2 9.8 36.2 8.6 41.8 10.2L42.8 12.4C38.2 14.6 33.2 15.6 29.2 15.9Z"/><circle cx="32" cy="19.4" r="1.9"/><circle cx="45.6" cy="11.2" r="1.9"/></g></svg>';
  var FLAG = '<svg viewBox="0 0 15 19" focusable="false"><rect x="0.5" y="0.5" width="1.6" height="18" fill="currentColor"/><g fill="currentColor"><rect x="2.1" y="1" width="3" height="3"/><rect x="8.1" y="1" width="3" height="3"/><rect x="5.1" y="4" width="3" height="3"/><rect x="11.1" y="4" width="3" height="3"/><rect x="2.1" y="7" width="3" height="3"/><rect x="8.1" y="7" width="3" height="3"/></g><rect x="2.1" y="1" width="12" height="9" fill="none" stroke="currentColor" stroke-width="0.8"/></svg>';
  function place(fill, bike, pct) {
    fill.style.width = pct + '%';
    bike.style.left = 'calc((100% - 44px) * ' + (pct / 100) + ')';
  }
  function renderMeter(total) {
    var header = document.querySelector('cart-drawer .drawer__header');
    if (!header) return;
    var m = header.parentNode.querySelector('.lm-meter');
    if (!m) { m = document.createElement('div'); m.setAttribute('aria-live', 'polite'); header.insertAdjacentElement('afterend', m); }
    if (!total) { m.hidden = true; lastPct = 0; return; }
    m.hidden = false;
    var left = THRESHOLD - total;
    var pct = Math.min(100, Math.round(total * 100 / THRESHOLD));
    var done = left <= 0;
    var from = lastPct === null ? 0 : lastPct;
    m.className = 'lm-meter' + (done ? ' is-done' : '') + (done && lastPct !== null && lastPct < 100 ? ' is-hit' : '');
    m.innerHTML = '<p class="lm-meter__text">' + (done ? '<b>Free US shipping unlocked.</b> Applied at checkout.' : 'You\'re <b>' + money(left) + '</b> away from free US shipping.') + '</p>'
      + '<div class="lm-meter__road" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress to free shipping">'
      + '<div class="lm-meter__track"><span class="lm-meter__fill"></span></div>'
      + '<span class="lm-meter__bike" aria-hidden="true">' + BIKE + '</span>'
      + '<span class="lm-meter__flag" aria-hidden="true">' + FLAG + '</span></div>';
    var fill = m.querySelector('.lm-meter__fill');
    var bike = m.querySelector('.lm-meter__bike');
    fill.style.transition = bike.style.transition = 'none';
    place(fill, bike, from);
    void fill.offsetWidth;
    fill.style.transition = bike.style.transition = '';
    requestAnimationFrame(function () { requestAnimationFrame(function () { place(fill, bike, pct); }); });
    lastPct = pct;
  }
  function refreshMeter() {
    if (meterBusy || !document.querySelector('cart-drawer')) return;
    meterBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { meterBusy = false; renderMeter(c.total_price || 0); }).catch(function () { meterBusy = false; });
  }
  function watchDrawer() {
    var root = document.getElementById('CartDrawer');
    if (!root || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      if (root.querySelector('.lm-meter')) return;
      clearTimeout(t); t = setTimeout(refreshMeter, 60);
    }).observe(root, { childList: true, subtree: true });
  }

  /* size guide link on the product page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-sizeguide]');
    if (!b) return;
    e.preventDefault();
    var d = document.getElementById('lm-size');
    if (!d) return;
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var booted = false;
  function boot() {
    if (booted) return; booted = true;
    initReveal(); refreshMeter(); watchDrawer();
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshMeter, 150); }); } catch (err) {}
  }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState === 'complete') boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', initReveal);
})();
